<div class="modal-header">
  <h4 class="modal-title">{{ modalTitle }}</h4>
  <button type="button" class="btn-close no-outline" aria-label="close" (click)="modal.dismiss()"></button>
</div>
<div class="modal-body pb-4">
  <form [formGroup]="searchForm" class="inputGroup" *ngIf="!hasColumnFilters">
    <input type="search" class="form-control no-outline mb-3" formControlName="search" placeholder="{{ 'search' | label : 'general' | async }}" />
    <span class="highlight"></span>
    <span class="bar"></span>
  </form>

  <ul class="list-group list-group-flush basic-select-list">
    <li class="list-group-item basic-select-header">
      <div class="d-flex align-items-center basic-select-row">
        <div class="basic-select-selection"></div>
        <div *ngFor="let property of visibleProperties" class="basic-select-cell" [class.cursor-pointer]="property.sortable" (click)="property.sortable && changeSort(property.property)">
          {{ property.display }}
          <i *ngIf="property.sortable" class="fas ms-1" [ngClass]="getSortIcon(property.property)"></i>
        </div>
      </div>
    </li>
    <li *ngIf="hasColumnFilters" class="list-group-item basic-select-filter-row">
      <div class="d-flex align-items-center basic-select-row">
        <div class="basic-select-selection"></div>
        <div *ngFor="let property of visibleProperties" class="basic-select-cell">
          <ng-container *ngIf="property.status; else textFilter">
            <select class="form-select form-select-sm" [(ngModel)]="columnFilters[property.property]" (change)="applyColumnFilter()">
              <option [ngValue]="null">{{ 'all' | label : 'general' | async }}</option>
              <option [ngValue]="true">{{ 'active' | label : 'general' | async }}</option>
              <option [ngValue]="false">{{ 'inactive' | label : 'general' | async }}</option>
            </select>
          </ng-container>
          <ng-template #textFilter>
            <input *ngIf="property.filterable" type="search" class="form-control form-control-sm" [(ngModel)]="columnFilters[property.property]" (ngModelChange)="applyColumnFilter()" [placeholder]="property.display" />
          </ng-template>
        </div>
      </div>
    </li>
    <li class="list-group-item cursor-pointer basic-select-item" *ngFor="let item of viewList; let i = index" (click)="selectItem(i)">
      <div class="d-flex align-items-center basic-select-row">
        <div class="basic-select-selection">
          <input *ngIf="!multiSelect" type="radio" class="form-check-input m-0" [checked]="item.selected" />
          <input *ngIf="multiSelect" type="checkbox" class="form-check-input m-0" [checked]="item.selected" />
        </div>
        <div *ngFor="let property of visibleProperties" class="basic-select-cell" [ngClass]="property.classes">
          <ng-container *ngIf="property.status; else regularValue">
            {{ getStatusLabel(item) ? (getStatusLabel(item) | label : 'general' | async) : '—' }}
          </ng-container>
          <ng-template #regularValue>{{ getDisplayValue(item, property.property) }}</ng-template>
        </div>
      </div>
    </li>
  </ul>

  <div class="d-flex justify-content-center mt-4">
    <ngb-pagination [(page)]="pagingState.page" [pageSize]="pagingState.pageSize" [collectionSize]="count" (pageChange)="changePage($event)"></ngb-pagination>
  </div>

  <button type="button" class="btn" (click)="confirmSelection()">
    {{ 'confirm' | label : 'general' | async }}
  </button>
</div>
